import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { CartProvider } from './contexts/CartContext'
import { Navbar } from './components/Navbar'
import { ProtectedRoute } from './components/ProtectedRoute'
import { Home } from './pages/Home'
import { Login } from './pages/Login'
import { StorePage } from './pages/StorePage'
import { Checkout } from './pages/Checkout'
import { SuperAdminDashboard } from './pages/admin/Dashboard'
import { StoreAdminLayout } from './pages/store-admin/Layout'
import { StoreOverview } from './pages/store-admin/Overview'
import { StoreProducts } from './pages/store-admin/Products'
import { StoreOrders } from './pages/store-admin/Orders'
import { TrabajadorPanel } from './pages/trabajador/Panel'

function NotFound() {
  return (
    <div className="not-found">
      <div className="nf-code">404</div>
      <h1>Página no encontrada</h1>
      <a href="/">← Volver al inicio</a>
    </div>
  )
}

function AppRoutes() {
  return (
    <>
      <Navbar />
      <Routes>
        {/* Public */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/tiendas/:id" element={<StorePage />} />
        <Route path="/checkout" element={<Checkout />} />

        {/* Super Admin */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute roles={['super_admin']}>
              <SuperAdminDashboard />
            </ProtectedRoute>
          }
        />

        {/* Store Admin */}
        <Route
          path="/mi-tienda"
          element={
            <ProtectedRoute roles={['admin_ferreteria']}>
              <StoreAdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<StoreOverview />} />
          <Route path="productos" element={<StoreProducts />} />
          <Route path="pedidos" element={<StoreOrders />} />
        </Route>

        {/* Trabajador */}
        <Route
          path="/trabajador"
          element={
            <ProtectedRoute roles={['trabajador']}>
              <TrabajadorPanel />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  )
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <AppRoutes />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  )
}
